export default __webpack_public_path__ + "static/media/recruiter-hero.173afd54.png";